<router-outlet>
    
</router-outlet>
<!-- <h1 class="loader-color" *ngIf="loader.isLoader">Loading...</h1> -->
